import { chartAnimation } from './animations/chartAnimations';
import canvasDrawer from '../canvasDrawer';
import { checkFPS } from '../../helpers/gameCanvasHelper';

let fps = 60;

const trackFpsChange = () => {
  checkFPS().then((res) => {
    fps = res;
    trackFpsChange();
  });
};
trackFpsChange();

const engine = () => {
  const pathname = window.location.pathname;

  if (pathname === '/luckydeal/game') {
    chartAnimation(fps);
    canvasDrawer();
  }
  requestAnimationFrame(engine);
};
engine();

export default engine;
